import { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

const METHOD_STYLES = {
  POST: "border-emerald-500/40 bg-emerald-500/10 text-emerald-400",
  PUT: "border-orange-500/40 bg-orange-500/10 text-orange-400",
  PATCH: "border-cyan-500/40 bg-cyan-500/10 text-cyan-400",
  DELETE: "border-red-500/40 bg-red-500/10 text-red-400",
};

export default function ActivityTab() {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    api.get("/admin/activity").then((r) => setEntries(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);

  return (
    <div className="grid gap-3" data-testid="activity-admin">
      <p className="flex items-center gap-2 text-xs text-slate-500">
        <Activity className="h-4 w-4 text-orange-500" />
        Les 200 dernières actions réussies des administrateurs (créations, modifications, suppressions).
      </p>
      {entries.length === 0 ? (
        <p data-testid="activity-empty" className="text-slate-500">Aucune activité enregistrée pour le moment.</p>
      ) : (
        entries.map((e) => (
          <div key={e.id} data-testid={`activity-row-${e.id}`}
            className="flex flex-wrap items-center gap-3 rounded-lg border border-slate-700/60 bg-[#060B18] px-4 py-2.5">
            <span className={`rounded border px-2 py-0.5 font-mono2 text-[10px] font-bold ${METHOD_STYLES[e.method] || "border-slate-600 text-slate-300"}`}>
              {e.method}
            </span>
            <span className="min-w-0 flex-1 truncate font-mono2 text-xs text-slate-300">{e.path}</span>
            <span className="text-xs font-semibold text-orange-400">{e.email}</span>
            <span className="text-[11px] text-slate-500">{new Date(e.created_at).toLocaleString("fr-FR")}</span>
          </div>
        ))
      )}
    </div>
  );
}
